import { superAdminService } from "../_services/superadmin.service";

export const superAdminAction = {
  getCctvDistricts,
  updateCctvDistrict,
  getCctnsMissingPoliceStations,
  updateCctnsDistrictSecondaryName,
};
function getCctvDistricts() {
  return superAdminService.getCctvDistricts();
}

function updateCctvDistrict(values) {
  return superAdminService.updateCctvDistrict(values);
}

function getCctnsMissingPoliceStations() {
  return superAdminService.getCctnsMissingPoliceStations();
}

function updateCctnsDistrictSecondaryName(values) {
  return superAdminService.updateCctnsDistrictSecondaryName(values);
}
